import { IKeyFigure, ITags, IFilterTag } from "src/api/server/extended-search.types";
import { IKeyFigureValue, ITagValue } from "src/components/pages/search/components/types";
import { REAL_MONEY_TAG, SAVINGS_PLAN_TAG } from "src/components/pages/search/constants";
import { ISearchRequestParamsOmitCountry } from "src/components/pages/search/search.types";
import { getSearchState, ISearchStore } from "src/components/pages/search/store/search-store";

export const getShouldSetIsInvestable = ({ newSelectedTags, isInvestable }: { newSelectedTags: ITagValue[]; isInvestable: boolean }) =>
    newSelectedTags.some(tag => tag.value === SAVINGS_PLAN_TAG) || (newSelectedTags.some(tag => tag.value === REAL_MONEY_TAG) && !isInvestable);

export const isKeyFigureValueDefault = (keyFigure: IKeyFigureValue, keyFiguresData: readonly IKeyFigure[]) => {
    const keyFigureDefaultValue = keyFiguresData.find(keyFigureValue => keyFigureValue.id === keyFigure.id);

    if (keyFigureDefaultValue) {
        const defaultKeyFigureMinimum = keyFigureDefaultValue.steps[0];
        const defaultKeyFigureMaximum = keyFigureDefaultValue.steps[keyFigureDefaultValue.steps.length - 1];
        return keyFigure.min === defaultKeyFigureMinimum && keyFigure.max === defaultKeyFigureMaximum;
    } else {
        return false;
    }
};

export const getMappedStore = (store: ISearchStore): ISearchRequestParamsOmitCountry => ({
    sortDirection: store.sortDirection,
    sortByRankingId: store.selectedRanking?.id ?? null,
    brokersIds: store.brokersIds,
    tagsIds: store.tags.map(tag => tag.value),
    keyFigures: store.keyFigures,
    query: store.query,
    isInvestable: store.isInvestable,
    isAtInvestable: store.isAtInvestable,
    isChInvestable: store.isChInvestable,
    leverageProductsIndication: store.leverageProductsIndication,
    selectedFigures: [...store.selectedFigures],
});

const getTagGroupName = (tagsData: ITags, value: string) =>
    Object.keys(tagsData).find(key => tagsData[key as keyof ITags].tags.some((tag: IFilterTag) => tag.urlIdentifier === value));

const getSelectedTagIdFromGroup = (groupTags: IFilterTag[], selectedTags: ReadonlyArray<ITagValue>) => {
    const selectedIds = selectedTags.map(tag => tag.value);
    return groupTags.filter((tag: IFilterTag) => selectedIds.includes(tag.urlIdentifier))[0]?.urlIdentifier;
};

export const getNewSelectedTags = (isChecked: boolean, value: string, isPopular: boolean, tags: ITags, selectedTags: ReadonlyArray<ITagValue>) => {
    if (isChecked) {
        const tagGroupName = getTagGroupName(tags, value);
        const isMutuallyExclusive = tagGroupName && tags[tagGroupName as keyof ITags].isMutuallyExclusive;
        const selectedTagIdFromGroup = tagGroupName && getSelectedTagIdFromGroup(tags[tagGroupName as keyof ITags].tags, selectedTags);
        let updatedTags = selectedTags;

        if (isMutuallyExclusive && selectedTagIdFromGroup) {
            updatedTags = getSearchState().tags.filter(tag => tag.value !== selectedTagIdFromGroup);
        }
        return [...updatedTags, { value, isPopular }];
    } else {
        return selectedTags.filter(tag => tag.value !== value);
    }
};

export const isPopularSavingsPlanTagSelected = (tags: readonly ITagValue[]) => tags.some(tag => tag.isPopular && tag.value === SAVINGS_PLAN_TAG);
